
import React, { useEffect, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination, DisplaySearchCriteria } from '../../../components/TapUi';
import { Modal } from 'bootstrap';
import { Helmet } from 'react-helmet';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const SubSectionList = ({ history }) => {

    const subSectionUrl =   BACKOFFICE_BASE_URL + '/sub_section';

    const permissions       =   useSelector(state => state.app.acl_info?.permissions || []);

    const initSearchForm = {
        search_name: '',
    };

    const searchFormLabel = {
        search_name: 'Name : ',
    };

    const [listingLoading, setListingLoading]   =   useState(false);
    const [subSectionListing, setSubSectionListing] =   useState([]);
    const [listingMeta, setListingMeta] = useState(null);
    const [subSectionSearchForm, setSubSectionSearchForm]   =   useState({ ...initSearchForm });
    const [submittedSubSectionFilterForm, setSubmittedSubSectionFilterForm] =   useState({ ...initSearchForm });
    const [formSearchedElems, setFormSearchedElems] =   useState([]);
    const [searchModal, setSearchModal] =   useState(null);
    const access_token  =   useSelector(state => state.auth.access_token);

    useEffect(() => {
        loadListingTblData(1);
        const modal =   new Modal(document.getElementById('searchSectionModal'), { keyboard: false, backdrop: false });
        setSearchModal(modal);
    }, [formSearchedElems]);

    const loadListingTblData = (page = 1) => {
        setListingLoading(true);
        const params = { page: page, per_page: 50, ...submittedSubSectionFilterForm };
        HttpAPICall.withAthorization('GET', subSectionUrl + '/list', access_token, params, {}, (resp) => {
            const respData = resp.data;
            setSubSectionListing(respData.data);
            setListingMeta({
                'from'          :   respData.from, 
                'to'            :   respData.to, 
                'total'         :   respData.total, 
                'last_page'     :   respData.last_page, 
                'per_page'      :   respData.per_page, 
                'current_page'  :   respData.current_page
            });
        }).then(() => setListingLoading(false));
    };

    const addSubSectionFormInit = () => {
        history.push('/add_subsection');
    };
    const editsubSectionInit = (item) => {
        history.push({ pathname: `/add_subsection`, state: { editSubSectionData: item } });
    };
    
    const submitSearchForm = (e) => {
        e && e.preventDefault()
        let serachFormKeys = Object.keys(subSectionSearchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {

            let label = searchFormLabel[key];
            let value = subSectionSearchForm[key];

            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key == 'search_name') {
                        show_val = subSectionSearchForm ? subSectionSearchForm.search_name : '';
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        setSubmittedSubSectionFilterForm(pre => ({ ...pre, ...subSectionSearchForm }));
        setFormSearchedElems(pre => ([...searchedElems]));
        searchModal.hide();
    }

    const subSectionSearchClear = () => {
        setFormSearchedElems([]);
        setSubSectionSearchForm({ ...initSearchForm });
        setSubmittedSubSectionFilterForm({ ...initSearchForm });
        loadListingTblData(1);
        searchModal.hide();
    };

    const deleteSubSection  =   (id) => {
        swal({
            title: "Delete",
            text: "Are you sure want to delete this permanently?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        })
        .then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', subSectionUrl + '/delete/' + id, access_token,{},{},(resp) => {
                    toast.success(resp.data.msg, {position: toast.POSITION.TOP_RIGHT});
                    loadListingTblData(1)
                });
            }
        });
    }

    const subSectionJsx = () => {
        return (
            <Ax>
                <div className="page_title row m0">
                    <div>
                        <h3>Sub Section List</h3>
                        <div className="text-end mt15">
                            <Ax>
                                {permissions.includes('asset_sub_section_add') && 
                                <button type="button" className="btn btn-primary" onClick={addSubSectionFormInit}>New</button>
                                }
                                <button type="button" className="btn btn-secondary" onClick={() => searchModal.show()} disabled={listingLoading}>
                                    <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                                </button>
                            </Ax>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{subSectionListingJsx()}</div>
                    </div>
                </div>
            </Ax>
        );
    };

    const subSectionListingJsx = () => {
        return (
            <Ax>
                <DisplaySearchCriteria searchedElems={formSearchedElems} onClearFilter={subSectionSearchClear} />
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        <tr className='text-center'>
                            <Ax>
                                <th style={{ width: "5%" }}>S.No</th>
                                <th>Sub Section</th>
                                <th className="text-center" style={{ width: "25%" }}>Remark</th>
                                <th className="text-center" style={{ width: "10%" }}>Action</th>
                            </Ax>
                        </tr>
                    </thead>
                    <tbody>
                        {listingLoading
                            ? (<tr><td colSpan="5"><Loader /></td></tr>)
                            : (subSectionListing && subSectionListing.length > 0
                                ? (subSectionListing.map((item, index) => (
                                    <tr key={index}>
                                        <Ax>
                                            <td className='text-center'>{listingMeta ? listingMeta.from + index : index}</td>
                                            <td>{item.subcomponent ? item.subcomponent : "-"}</td>
                                            <td>{item.description ? item.description : "-"}</td>
                                            <td className='text-center'>
                                                <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                    {permissions.includes('asset_sub_section_edit') && 
                                                    <li onClick={() => editsubSectionInit(item)}><Link className="dropdown-item"  role="button">Edit</Link></li>
                                                    }
                                                    {permissions.includes('asset_sub_section_delete') && 
                                                            <li onClick={() => deleteSubSection(item.id)}><Link className="dropdown-item" role="button">Delete</Link></li>
                                                    }
                                                </ul>
                                            </td>
                                        </Ax>
                                    </tr>
                                )))
                                : (<tr><td colSpan="5" className="text-center">No Records</td></tr>))
                        }
                    </tbody>
                </table>
                <DisplayListPagination
                    meta={listingMeta}
                    onPageChange={(e) => loadListingTblData(e.selected + 1)}
                />
            </Ax>
        );
    };
    const searchModalJsx = () => {
        return (
            <div className="modal fade" id="searchSectionModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Sub Section Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form id="subSectionSearchForm" onSubmit={submitSearchForm}>
                            <div className="modal-body">
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Name</label>
                                    <div className="col-sm-10">
                                        <input
                                            name="search_name"
                                            type="text"
                                            value={subSectionSearchForm.search_name}
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={(e) => setSubSectionSearchForm(pre => ({ ...pre, ...subSectionSearchForm, search_name: e.target.value }))}
                                            placeholder="Please enter SubSection Name"
                                            style={{ height: "30px", fontSize: "93%" }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Sub Section Listing</title></Helmet>
            {subSectionJsx()}
            {searchModalJsx()}
        </ApplicationLayout>
    );
};

export default SubSectionList;
